// Small formatting helpers. Dates arrive as ISO strings (UTC for timestamps, plain for dates).

export function day(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = iso.length === 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function when(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function usd(v: number | null | undefined, digits = 2): string {
  if (v === null || v === undefined) return '—';
  return `$${v.toFixed(v > 0 && v < 0.01 ? 4 : digits)}`;
}

export function words(s: string): string {
  return s.replace(/_/g, ' ');
}

export function seconds(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '';
  return ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(1)} s`;
}
